export default __webpack_public_path__ + "static/media/Fptubelight.4ab2bf23.png";